import { SearchVisitor } from '../model/searchvisitor';
import { Identity } from '@sdbn/appclient';
import { VisitReservation } from '../model/visit-reservation';
import { Injectable } from '@angular/core';
import { HttpService } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VisitReservationService {

  constructor(private tmcHttpService: HttpService) { }

  public getNewVisitReservation(visitorIdentity: Identity): Observable<VisitReservation> {
    const url = `${environment.visitReservationEndpoint}/newreservation`;
    return this.tmcHttpService.postWithContext<VisitReservation>(url, visitorIdentity);
  }

  public getVisitReservation(identity: Identity): Observable<VisitReservation> {
    return this.tmcHttpService.postWithContext<VisitReservation>(environment.visitReservationEndpoint + '/details', identity);
  }

  public saveVisitReservation(personalVisit: VisitReservation): Observable<any> {
    return this.tmcHttpService.postWithContext<any>(environment.visitReservationEndpoint + '/save', personalVisit);
  }

  public deleteVisitReservation(identity: Identity): Observable<any> {
    return this.tmcHttpService.postWithContext<VisitReservation>(environment.visitReservationEndpoint + '/delete', identity);
  }

  public search(searchVisitor: SearchVisitor): Observable<any> {
    return this.tmcHttpService.postWithContext<any>(environment.visitReservationEndpoint + '/search', searchVisitor);
  }


}
